import {
    TRACKING_PLATFORM_TYPE_RESPONSIVE,
    TRACKING_SITE_AREA_MOBILITY,
    MAP_SALESCHANNEL_TO_TRACKING_FILTER,
    getSiteStructure,
    getLoginData,
    getCustomerFlow,
    TrackingBtx,
    TrackingLoginStatus,
    TrackingPageType,
    PageViewTrackingData,
    PageViewTrackingDataWithError,
    TrackingError,
} from '@vfde-sails/tracking';
import { createTrackingFilterObject } from './createTrackingFilterObject';
import { TrackingData } from '../../../interfaces/tracking';
import { TRACKING_PAGENAME } from '../../../app/constants';
import { BTX_BNT } from '@vfde-sails/constants';

/**
 * Create the page view tracking object
 */
export const createPageViewTrackingData = (trackingData: TrackingData): PageViewTrackingData => {
    const siteStructure = getSiteStructure(TRACKING_PAGENAME, BTX_BNT);
    const loginStatus = getLoginData() ? TrackingLoginStatus.LoggedIn : TrackingLoginStatus.NotLoggedIn;
    const lineOfCustomer = getCustomerFlow(trackingData.salesChannel);
    const pageViewTrackingData: PageViewTrackingData = {
        /* eslint-disable jsdoc/require-jsdoc, @typescript-eslint/naming-convention, camelcase */
        appliedFilters: [],
        page_levels: siteStructure,
        page_type: TrackingPageType.ProductListing,
        login_status: loginStatus,
        site_area: TRACKING_SITE_AREA_MOBILITY,
        platform_type: TRACKING_PLATFORM_TYPE_RESPONSIVE,
        flow_type: trackingData.flowType,
        business_transaction_type: TrackingBtx.Bnt,
        line_of_customer: lineOfCustomer,
        /* eslint-enable jsdoc/require-jsdoc, @typescript-eslint/naming-convention, camelcase */
    };

    if (trackingData.manufacturer) {
        pageViewTrackingData.appliedFilters!.push(
            createTrackingFilterObject(trackingData.manufacturer as string),
        );
    }

    if (trackingData.subscriptionId) {
        pageViewTrackingData.appliedFilters!.push(
            createTrackingFilterObject(MAP_SALESCHANNEL_TO_TRACKING_FILTER[trackingData.salesChannel]),
        );
    }

    // track facets from url param as Filter objects
    pageViewTrackingData.appliedFilters!.push(...trackingData.selectedFacets
        .map(facet => createTrackingFilterObject(facet.label)));

    if (!trackingData.manufacturer && !trackingData.subscriptionId && trackingData.selectedFacets?.length === 0) {
        delete pageViewTrackingData.appliedFilters;
    }

    return pageViewTrackingData;
};

/**
 * Create the page view tracking object with error
 */
export const createPageViewTrackingDataWithError = (
    trackingData: TrackingData,
    trackingError: TrackingError,
): PageViewTrackingDataWithError => ({
    ...createPageViewTrackingData(trackingData),
    ...trackingError,
});
